// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2p3jqdtxUZHv","content__wrp":"_2jc5Dk35-XSA"};